import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    fallbackLng: {
      // ar: ['ar'],
      // be: ['be'],
      // de: ['de'],
      // en: ['en'],
      // es: ['es'],
      // it: ['it'],
      // ko: ['ko'],
      // ru: ['ru'],
      // ua: ['ua'],
      // cz: ['cz'],
      default: ['en'],
    },
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    // react i18next special options (optional)
    // override if needed - omit if ok with defaults
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    },

    detection: {
      order: ['localStorage'],
      // order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lang',
    },

    backend: {
      loadPath: '/lang/{{lng}}/{{ns}}.json',
    },

    ns: ['translation'],
    defaultNS: 'translation',
  })

export default i18n
